/** @format */

import React, {useMemo, useState} from 'react';

import {Box, Popover, PopoverProps} from '@mui/material';
import {useTranslation} from 'react-i18next';

import {PickerLeft, PickerList, PickerPaper, PickerRight, PickerRow, PickerSearch} from './styles';

export interface GoalPickerGoal {
  id: number;
  name: string;
  counterId: number;
  counterName: string;
}

interface GoalPickerProps {
  open: boolean;
  anchorEl: PopoverProps['anchorEl'];
  goals: GoalPickerGoal[];
  onSelect: (goal: GoalPickerGoal) => void;
  onClose: () => void;
  headerSlot?: React.ReactNode;
}

const GoalPicker = ({open, anchorEl, goals, onSelect, onClose, headerSlot}: GoalPickerProps) => {
  const {t} = useTranslation();
  const [search, setSearch] = useState('');

  const filteredGoals = useMemo(() => {
    const query = search.trim().toLowerCase();
    if (!query) return goals;
    return goals.filter(
      g =>
        g.name.toLowerCase().includes(query) ||
        g.counterName.toLowerCase().includes(query) ||
        String(g.counterId).includes(query) ||
        String(g.id).includes(query),
    );
  }, [search, goals]);

  const handleClose = () => {
    setSearch('');
    onClose();
  };

  const handleSelect = (goal: GoalPickerGoal) => {
    setSearch('');
    onSelect(goal);
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}
      transformOrigin={{vertical: 'top', horizontal: 'left'}}
    >
      <PickerPaper>
        <Box sx={{p: 2}}>
          <PickerSearch
            placeholder={t('Название или ID цели', 'Название или ID цели')}
            inputProps={{'aria-label': t('Название или ID цели', 'Название или ID цели')}}
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
        </Box>
        <PickerList>
          {headerSlot}
          {filteredGoals.map(g => (
            <PickerRow key={g.id} onClick={() => handleSelect(g)}>
              <PickerLeft>
                <Box sx={{fontWeight: 400, fontSize: '14px'}}>{g.counterName}</Box>
                <Box sx={{opacity: 0.7, fontSize: '14px'}}>{g.counterId}</Box>
              </PickerLeft>
              <PickerRight>
                <Box sx={{fontWeight: 400, fontSize: '14px'}}>{g.name}</Box>
                <Box sx={{opacity: 0.7, fontSize: '14px'}}>№ {g.id}</Box>
              </PickerRight>
            </PickerRow>
          ))}
        </PickerList>
      </PickerPaper>
    </Popover>
  );
};

export default GoalPicker;
